// @flow
import React, { Component } from 'react'

type Props = {
  lat?: number, // eslint-disable-line react/no-unused-prop-types
  lng?: number, // eslint-disable-line react/no-unused-prop-types
  address?: string, // eslint-disable-line react/no-unused-prop-types
  zoom?: number, // eslint-disable-line react/no-unused-prop-types
  style?: Object
}

class GoogleMap extends Component {
  componentDidMount() {
    this.plot(this.props)
  }

  componentWillReceiveProps(nextProps: Props) {
    this.plot(nextProps)
  }

  props: Props

  plot(props: Props) {
    if (typeof window !== 'undefined' && window.google) {
      if (props.lat && props.lng) {
        this.plotByCoordinates(props)
      } else {
        this.plotByAddress(props)
      }
    }
  }

  plotByAddress = (props: Props) => {
    const mapOptions = {
      zoom: props.zoom || 14
    }
    const map = new window.google.maps.Map(this.map, mapOptions)
    const geocoder = new window.google.maps.Geocoder()
    geocoder.geocode({ address: props.address }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK) {
        map.setCenter(results[0].geometry.location)
        const marker = new window.google.maps.Marker({
          // eslint-disable-line no-unused-vars
          map,
          position: results[0].geometry.location
        })
      }
    })
  }

  plotByCoordinates = (props: Props) => {
    const location = {
      lat: Number(props.lat),
      lng: Number(props.lng)
    }
    const mapOptions = {
      center: location,
      zoom: props.zoom || 14
    }
    const map = new window.google.maps.Map(this.map, mapOptions)
    const marker = new window.google.maps.Marker({
      // eslint-disable-line no-unused-vars
      position: location,
      map
    })
  }

  map: HTMLElement

  render() {
    return (
      <div
        ref={(node) => {
          this.map = node
        }}
        style={{ width: '100%', height: '300px', ...this.props.style }}
      />
    )
  }
}

export default GoogleMap



// WEBPACK FOOTER //
// ./src/components/GoogleMap/index.js